/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Bound_ToInputs */

const en_marketing_bound_to = /** @type {(inputs: Marketing_Bound_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bound to`)
};

const es_marketing_bound_to = /** @type {(inputs: Marketing_Bound_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinculado a`)
};

const fr_marketing_bound_to = /** @type {(inputs: Marketing_Bound_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lié à`)
};

/**
* | output |
* | --- |
* | "Bound to" |
*
* @param {Marketing_Bound_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_bound_to = /** @type {((inputs?: Marketing_Bound_ToInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Bound_ToInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_bound_to(inputs)
	if (locale === "es") return es_marketing_bound_to(inputs)
	return fr_marketing_bound_to(inputs)
});